import { ApplicationsDataState, ApplicationsState } from './types';

export const INITIAL_APPLICATIONS_DATA_STATE: ApplicationsDataState = {
  application: null,
  applications: [],
};

export const INITIAL_APPLICATIONS_STATE: ApplicationsState = {
  ...INITIAL_APPLICATIONS_DATA_STATE,
  applicationLoading: false,
  applicationError: null,
  applicationSuccess: null,

  applicationsLoading: false,
  applicationsError: null,
  applicationsSuccess: null,
};
